import i18n from "i18next";
import {initReactI18next} from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: {
      "Choose as tour": "Choose as tour",
      "Buy ticket": "Buy ticket",
      "hours": "h",
      "Available dates": "Available dates",
      "Departure date": "Departure date",
      "Step": "Step",
      "at": "at",
      "Checkout": "Checkout",
      "Select departure date and number of passengers": "Select departure date and number of passengers",
      "Number of passengers": "Number of passengers",
      "Please note that the number of passengers in one order should not exceed 4 people.": "Please note that the number of passengers in one order should not exceed 4 people.",
      "Choose a suite": "Choose a suite",
      "Passenger data": "Passenger data",
      "Next step": "Next step",
      "Pay": "Pay",
      "Select": "Select",
      "Selected": "Selected",
      "Suite": "Suite",
      "Cost": "Cost",
      "Count seats": "Count seats",
      "ff": "{{count}} adult",
      "ff_plural": "{{count}} adult",
      "cc": "{{count}} children",
      "cc_plural": "{{count}} children",
      "bb": "{{count}} baby",
      "bb_plural": "{{count}} baby",
      "Adult": "Adult",
      "Children": "Children",
      "over 13 years of age": "over 13 years of age",
      "under 13 years of age": "under 13 years of age",
      "Children without a separate seat": "Children without a separate seat",
      "under 7 years of age": "under 7 years of age",
      'January': 'January',
      'February': 'February',
      'March': 'March',
      'April': 'April',
      'May': 'May',
      'June': 'June',
      'July': 'July',
      'August': 'August',
      'September': 'September',
      'October': 'October',
      'November': 'November',
      'December': 'December',
      'Previous month': "Previous month",
      'Next month': "Next month",
      'mo': "mo",
      'tu': "tu",
      'we': "we",
      'th': "th",
      'fr': "fr",
      'sa': "sa",
      'su': "su",
      "DD.MM.YYYY" : 'DD.MM.YYYY',
      "The surname and first name(s)": 'The surname and first name(s)',
      "Birth date": 'Birth date',
      "Type document" : "Type document",
      "Number document" : "Number document",
      "Email" : "Email",
      "Phone" : "Phone",
      "Max count seats": "Max count seats",
      "Cost seat": "Cost seat",
      "Cost suite": "Cost suite",
      "Food" : "Food",
      "Free" : "Free",
      'd': "day",
      'h': "hours",
      'departure' : 'departure',
      'Januarys': 'January',
      'Februarys': 'February',
      'Marchs': 'March',
      'Aprils': 'April',
      'Mays': 'May',
      'Junes': 'June',
      'Julys': 'July',
      'Augusts': 'August',
      'Septembers': 'September',
      'Octobers': 'October',
      'Novembers': 'November',
      'Decembers': 'December',
      'AppFooter' : 'Selected:',
      'Contact' : "Contact",
      'Passengers' : "Passengers",
      'Passenger' : "Passenger",
      "totalOrder": "Suite - {{suite}}, pansion -  {{pansion}}",
      "total" : "total",
      "suiteNum" : "suite number",
      'AppFooterNote' : 'Choose departure date and number of passengers',
      'checkout.eatnote': "You must specify a date of birth",
      'success.header': "Your order is confirmed!",
      'success.suite_cost': "Suite cost",
      'success.eat_cost': "Cost of food",
      'success.cost': "Total",
      'success.order': "Order",
      'success.route': "Tour",
      'success.departure': "Date departure",
      'success.suite': "Suite",
      'success.email': "Email",
      'success.phone': "Phone",
      'success.tickets': "Passengers",
      'success.ticket': "Passenger",
      'success.fio': "Name",
      'success.birthday': "Birthday",
      'success.doctype': "Document",
      'success.docnum': "Document Id",
      'success.eat': "Food",

    }
  },
  ru: {
    translation: {
      "Choose as tour": "Выберете тур",
      "Buy ticket": "Оформить тур",
      "hours": "часов",
      "Available dates": "Известные даты отправления лайнера",
      "Departure date": "Дата отправления",
      "Step": "Шаг",
      "at": "из",
      "Checkout": "Оформление тура",
      "Select departure date and number of passengers": "Выберите дату отправления и количество пассажиров",
      "Number of passengers": "Количество пассажиров",
      "Please note that the number of passengers in one order should not exceed 4 people.": "Обращаем ваше внимание, что число пассажиров в одном заказе не должно превышать 4 человек.",
      "Choose a suite": "Выберите палубу и каюту",
      "Passenger data": "Данные о пассажирах",
      "Next step": "Следующий шаг",
      "Pay": "Оплатить",
      "Select": "Выбрать",
      "Selected": "Выбрано",
      "Suite": "Каюта",
      "Cost": "Стоимость",
      "Count seats": "Количество мест",
      "bb_0": "{{count}} детский без предоставления места",
      "bb_1": "{{count}} детских без предоставления места",
      "bb_2": "{{count}} детских без предоставления места",
      "ff_0": "{{count}} взрослый",
      "ff_1": "{{count}} взрослых",
      "ff_2": "{{count}} взрослых",
      "cc_0": "{{count}} десткий",
      "cc_1": "{{count}} дестких",
      "cc_2": "{{count}} дестких",
      "Adult": "Взрослый",
      "Children": "Детский",
      "over 13 years of age": "старше 13 лет",
      "under 13 years of age": "до 13 лет",
      "Children without a separate seat": "Дети без предоставления места",
      "under 7 years of age": "до 7 лет",
      'January': 'Январь',
      'February': 'Февраль',
      'March': 'Март',
      'April': 'Апрель',
      'May': 'Май',
      'June': 'Июнь',
      'July': 'Июль',
      'August': 'Август',
      'September': 'Сентябрь',
      'October': 'Октябрь',
      'November': 'Ноябрь',
      'December': 'Декабрь',
      'Previous month': "Предыдущий месяц",
      'Next month': "Следующий месяц",
      'mo': "пн",
      'tu': "вт",
      'we': "ср",
      'th': "чт",
      'fr': "пт",
      'sa': "сб",
      'su': "вс",
      'd': "дней",
      'h': "часов",
      "The surname and first name(s)": 'ФИО',
      "Birth date": 'Дата рождения',
      "Type document" : "Документ",
      "Number document" : "Серия номер документа",
      "DD.MM.YYYY" : 'ДД.ММ.ГГГГ',
      "Email" : "Эл. адрес",
      "Phone" : "Контактный телефон",
      "Max count seats": "Макс. кол-во мест",
      "Cost seat": "Стоимость доп. места",
      "Cost suite": "Стоимость каюты",
      "Food" : "Питание",
      "Free" : "Бесплатно",
      'departure' : 'отправление',
      'Januarys': 'января',
      'Februarys': 'февраля',
      'Marchs': 'марта',
      'Aprils': 'апрела',
      'Mays': 'мая',
      'Junes': 'июня',
      'Julys': 'июля',
      'Augusts': 'августа',
      'Septembers': 'сентября',
      'Octobers': 'октября',
      'Novembers': 'ноября',
      'Decembers': 'декабря',
      'AppFooter' : 'Выбрано:',
      'Contact' : "Контактная информация",

      'Passengers' : "Пассажиры",
      'Passenger' : "Пассажир",
      "totalOrder": "Каюта - {{suite}}, пансион -  {{pansion}}",
      "total" : "к оплате",
      'AppFooterNote' : 'Выберете дату отправления и количество пассажиров',
      "suiteNum" : "каюта",
      'checkout.eatnote': "Необходимо указать дату рождения",
      'success.header': "Ваш заказа оформлен",
      'success.suite_cost': "Стоимость каюты",
      'success.eat_cost': "Стоимость питания",
      'success.cost': "Итого",
      'success.order': "Основные данные",
      'success.route': "Круиз",
      'success.departure': "Дата оправления",
      'success.suite': "Каюта",
      'success.email': "Email",
      'success.phone': "Контактный телефон",
      'success.tickets': "Пассажиры",
      'success.ticket': "Пассажир",
      'success.fio': "ФИО",
      'success.birthday': "Дата рождения",
      'success.doctype': "Документ",
      'success.docnum': "Номер документа",
      'success.eat': "Питание",

    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    debug: false,
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    lng: "ru",
    fallbackLng: "ru",
    react: {
      wait: true,
    },
  });

export default i18n;
